import React from 'react';

interface ZoomLiveLessonJoinProps {
  joinUrl: string;
  className?: string;
}

/** Centered join button when the lesson video URL is a Zoom live session */
export const ZoomLiveLessonJoin: React.FC<ZoomLiveLessonJoinProps> = ({
  joinUrl,
  className = '',
}) => (
  <div
    className={`absolute inset-0 flex items-center justify-center bg-slate-900 p-6 ${className}`}
  >
    <a
      href={joinUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-[#2D8CFF] text-white text-base sm:text-lg font-semibold hover:bg-[#2681eb] transition-colors shadow-lg focus:outline-none focus:ring-2 focus:ring-[#2D8CFF] focus:ring-offset-2 focus:ring-offset-slate-900"
    >
      الانضمام للحصة المباشرة
    </a>
  </div>
);
